module.exports = __webpack_public_path__ + "static/media/UltraVerticalSeries_GEA.5f72abbf.pdf";